import { Skeleton } from '@/components/ui/skeleton';

/**
 * Two-line loading skeleton used inside dashboard widget cards while
 * a single-headline metric (large value + caption) is being fetched.
 *
 * Consumed by ExecutiveDashboard, SafetyManagerDashboard, and
 * SupervisorDashboard widget cards.
 */
export function MetricSkeleton() {
  return (
    <div className="space-y-2">
      <Skeleton className="h-10 w-24" />
      <Skeleton className="h-3 w-40" />
    </div>
  );
}
